export const MAX_WIDTH = '1280px'
export const MOBILE_WIDTH = '1080px'
export const DESKTOP_WIDTH = '1081px'

export const CONTAINER_MAX_WIDTH = '1100px'
